/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import Item, { type SwitcherItemProps } from './item';
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@compiled/react';
import { useIsSwitcherTeam25TestCohort } from '../components/experiment-provider';

// add !important to override the default styles
// temp workaround to fix mix usage of emotion and compiled css: https://hello.jira.atlassian.cloud/browse/NAVX-551
const styles = cssMap({
	childItem: {
		paddingTop: `${token('space.050')} !important`,
		paddingRight: `${token('space.100')} !important`,
		paddingBottom: `${token('space.050')} !important`,
		paddingLeft: `${token('space.100')} !important`,
		background: `${token('elevation.surface.sunken')} !important`,
		color: `${token('color.text')} !important`,
		textDecoration: 'none',
		'&:hover': {
			background: `${token('color.background.neutral.hovered')} !important`,
		},
		'&:active': {
			background: `${token('color.background.neutral.pressed')} !important`,
		},
	},
	refreshedChildItem: {
		paddingTop: `${token('space.050')} !important`,
		paddingRight: `${token('space.100')} !important`,
		paddingBottom: `${token('space.050')} !important`,
		paddingLeft: `${token('space.100')} !important`,
		'&:hover': {
			background: `${token('color.background.neutral.subtle.hovered')} !important`,
		},
		'&:active': {
			background: `${token('color.background.neutral.subtle.pressed')} !important`,
		},
	},
	iconStyles: {
		marginRight: `${token('space.negative.050')}`,
	},
});

export default (props: SwitcherItemProps) => {
	const { icon, ...rest } = props;
	const isVisualRefreshEnabled = useIsSwitcherTeam25TestCohort();

	return (
		<Item
			icon={<span css={styles.iconStyles}>{icon}</span>}
			{...rest}
			css={[isVisualRefreshEnabled ? styles.refreshedChildItem : styles.childItem]}
		/>
	);
};
